import moment from "moment";
import { searchFlattenedObject } from "./searchFlattenedObject";

const filterFunctions = {
    selectFilter: (row, id, filterValue) => {
        if (!filterValue) return true;
        return row.original[id]?.toLowerCase() === filterValue.toString().toLowerCase() || false;
    },
    textFilter: (row, id, filterValue) => {
        if (!filterValue || !id) return true;

        const value = row.original[id] ?? ""; // si es undefined/null → ""

        return value.toString().toLowerCase().includes(filterValue.toLowerCase());
    },
    objectFilter: (row, id, filterValue) => {
        if (!filterValue) return true;
        return searchFlattenedObject(row.original[id], filterValue)
    },
    dateRangeFilter: (row, id, filterValue) => {
        if (!filterValue) return true;
        const [startDate, endDate] = filterValue;
        const date = new Date(row.original[id]);

        return date >= startDate && date <= endDate;
    },
    dateRangeFilterByPath: (accessorPath) => (row, id, filterValue) => {
        const [startDate, endDate] = filterValue ?? [];
        if (!startDate && !endDate) return true;

        const iso = accessorPath.split('.').reduce((acc, k) => acc?.[k], row.original);
        if (!iso) return false;

        const day = moment.utc(iso).format('YYYY-MM-DD');
        const from = startDate ? moment(startDate).format('YYYY-MM-DD') : null;
        const to = endDate ? moment(endDate).format('YYYY-MM-DD') : null;

        if (from && day < from) return false;
        if (to && day > to) return false;
        return true;
    }

}

export default filterFunctions;